export const LogoFilters = {
    SET_LOGO: 'IN_MEMORY.LOGO.SET',
};

export const setLogo = logo => ({
    type: LogoFilters.SET_LOGO,
    logo
});